import { t, Trans } from "@lingui/macro";
import { ExpandLessRounded, ExpandMoreRounded } from "@mui/icons-material";
import { UiBox, UiMenu, UiMenuItem, UiTypography } from "@smp/ui";
import { MouseEvent, useState } from "react";

import {
  IContextPolotnoTemplates,
  useContextPolotnoTemplates,
} from "../../../../context";
import { useStyles } from "./sort_dropdown.css";

export const SortDropdown = () => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const {
    actions: { changeSortBy },
    state: { sortBy },
  } = useContextPolotnoTemplates();

  const selectedType = {
    created_at: t`Old`,
    "-popularity": t`Popular`,
    "-created_at": t`Recent`,
  }[sortBy];

  const handleChange = (
    sortBy: IContextPolotnoTemplates["state"]["sortBy"],
  ) => {
    changeSortBy(sortBy);
    handleClose();
  };

  const handleOpen = (event: MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems: Array<{
    label: string;
    value: IContextPolotnoTemplates["state"]["sortBy"];
  }> = (
    [
      {
        label: t`Popular`,
        value: "-popularity",
      },
      {
        label: t`Recent`,
        value: "-created_at",
      },
      {
        label: t`Old`,
        value: "created_at",
      },
    ] as const
  ).filter((type) => type.value !== sortBy);

  return (
    <>
      <UiBox display="flex" alignItems="center">
        <UiTypography className={classes.title}>
          <Trans>Sort by: </Trans>
        </UiTypography>
        <UiBox onClick={handleOpen} className={classes.button}>
          <UiTypography className={classes.button_text}>
            {selectedType}
          </UiTypography>
          {Boolean(anchorEl) ? <ExpandLessRounded /> : <ExpandMoreRounded />}
        </UiBox>
      </UiBox>
      <UiMenu
        className={classes.menu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        autoFocus={false}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {menuItems.map((item) => (
          <UiMenuItem key={item.value} onClick={() => handleChange(item.value)}>
            {item.label}
          </UiMenuItem>
        ))}
      </UiMenu>
    </>
  );
};
